import { mapActions, mapGetters, mapMutations } from "vuex";
import { email, required } from "vuelidate/lib/validators";
import validation from "@/mixins/validation";

export default {
  name: "reset",
  data() {
    return {
      selectedFlow: 'email',
      payload: {
        value: "",
      },
      validationErrors: {},
    };
  },
  mixins: [validation],
  validations() {
    const payload = {
      value: {
        required,
      }
    }

    if (this.selectedFlow === 'email') {
      payload.value = {...payload.value, email};
    }

    return { payload };
  },
  computed: {
    ...mapGetters({
      isLoading: "auth/isLoading",
    }),
    phoneMask() {
      return '+380 (##) ###-##-##';
    },
    isValidEmail() {
      if (!this.payload || !this.payload.value) {
        return false;
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(this.payload.value);
    },
    isValidPhoneNumber() {
      if (!this.payload || !this.payload.value) {
        return false;
      }
      const cleaned = this.payload.value.trim().replace(/\D/g, '');
      const phoneRegex = /^\d{9,15}$/;
      return phoneRegex.test(cleaned.trim());
    },
    valueErrors() {
      const validators = {
        required: "validationRequired",
      }
      if (this.selectedFlow === 'email') {
        validators['email'] = "validationEmail"
      } else {
        delete validators['email'];
      }
      return this.computeErrors("payload", "value", validators);
    },
  },
  watch: {
    selectedFlow() {
      this.payload.value = "";
      this.$v.$reset();
    }
  },
  created() {
    document.getElementById("html").classList.add("hide");
  },
  methods: {
    ...mapMutations({
      changeLoginPopup: "popups/CHANGE_LOGIN_POPUP",
      changeResetPopup: "popups/CHANGE_RESET_POPUP",
      changeResetPhonePopup: "popups/CHANGE_RESTORE_PHONE_POPUP",
    }),
    ...mapActions({
      resetPassword: "auth/RESET_PASSWORD",
      resetPasswordWithPhone: "auth/RESET_PASSWORD_WITH_PHONE",
    }),
    changeModalFormToAuth() {
      this.changeResetPopup(false);
      this.changeLoginPopup(true);
    },
    sendPassword() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$v.$reset();
      if (this.selectedFlow === 'email') {
        this.resetPassword({ email: this.payload.value })
          .then(() => {
            this.$toasted.success(this.$t("messageResetPassword"));
            this.changeResetPopup(false);
          })
          .catch(error => {
            this.$toasted.error(error.data?.errors?.email || error.data.message);
          });
      } else {
        const phone = this.payload.value.replaceAll(/\D/g, "");
        this.resetPasswordWithPhone({ phone: `+380${phone}` })
          .then(() => {
            this.changeResetPopup(false);
            this.changeResetPhonePopup(true);
          })
          .catch(error => {
            this.$toasted.error(error.data?.errors?.email || error.data.message);
          });
      }
    },
  },
};
